import type { Reporter } from "./types";

/** A reporter that logs errors instead of sending them. For development builds. */
export function consoleReporter(): Reporter {
  return {
    init: () => {},
    captureException: ({ error, tags, extra }) => {
      console.error("[a3s-error-reporting]", error, { tags, extra });
    },
    addBreadcrumb: () => {},
    setUser: () => {},
    setTags: () => {},
  };
}
